<template>
  <div class="cv-template-main">

    <div class="module-item">

      <div class="cvs-title" v-if="temps.length"><span>推荐模板</span></div>
      <div class="recommend-template-box" v-if="temps.length">
        <div class="recommend-template-item">
          <div class="template-item-img-box" @click="previewCvFunc(temps[0])">
            <img class="template-item-img" :src="temps[0].cn_img || temps[0].en_img" alt="">
            <i class="iconfont iconzoom-out1"></i>
          </div>
          <div class="template-item-info">

            <div class="template-item-title">
              <h6>{{ temps[0].cn }}模板</h6>
              <span>推荐</span>
            </div>

            <p class="template-item-subtitle">{{ temps[0].temp_desc }}</p>

            <div class="template-item-hr-box">

              <div class="template-item-hr-header">
                <div>
                  <img class="template-item-hr-avatar" :src="temps[0].hr_avatar" alt="">
                  <span class="template-item-hr-name">{{ `${temps[0].hr_name} · ${temps[0].hr_position}` }}</span>
                </div>
                <img class="template-item-hr-icon" src="https://files.wondercv.com/PC/cvs/recommendedresume_pattern.png" alt="">
              </div>

              <p class="template-item-hr-desc">“{{ temps[0].hr_desc }}”</p>

            </div>

            <div class="template-item-btn-box pr">
              <!-- 中英文模板 -->
              <template v-if="temps[0].cn_img && temps[0].en_img">
                <button class="template-item-btn cn" @click="useTemplateFunc('cn')">中文模板</button>
                <button class="template-item-btn en" @click="useTemplateFunc('en')">英文模板</button>
              </template>
              <!-- 中文模板 -->
              <template v-else-if="temps[0].cn_img && !temps[0].en_img">
                <button class="template-item-btn cn" @click="useTemplateFunc('cn')">立即使用</button>
              </template>
              <!-- 英文模板 -->
              <template v-else-if="!temps[0].cn_img && temps[0].en_img">
                <button class="template-item-btn cn" @click="useTemplateFunc('en')">立即使用</button>
              </template>
              <a class="service-link pa" href="/service" target="_blank">
                <span class="iconfont iconbianji1"></span>
                <span class="text f_13">导师帮我写</span>
              </a>
            </div>

          </div>
        </div>
      </div>

      <!-- <div class="recommeed" v-if="temps.length">
        <div class="recommeed-menu" v-for="item in (temps.length > 2 ? 2 : temps.length)" :key="item">
          <div class="recommeed-title">
            <div class="">{{temps[item - 1]['cn'] + '模板'}}<i class="iconfont"></i></div>
            <div class="recommeed-btn">
              <button :class="option[item - 1] === 0 ? 'active' : ''" v-if="temps[item - 1]['cn_img']" @click.stop="setOption(item - 1, 0)">中文</button>
              <button :class="option[item - 1] === 1 ? 'active' : ''" v-if="temps[item - 1]['en_img']" @click.stop="setOption(item - 1, 1)">英文</button>
            </div>
          </div>
          <div class="recommeed-img">
            <img :src="temps[item - 1][option[item - 1] === 0 ? 'cn_img' : 'en_img']" alt="">
            <div class="recommeed-cover">
              <button class="recommeed-use" @click.stop="useTemplate(option[item - 1], temps[item - 1])">立即使用</button>
            </div>
          </div>
          <div class="recommeed-info">
            <span>推荐</span>{{temps[item - 1]['temp_desc']}}
          </div>
        </div>
      </div> -->

    </div>

    <div class="module-item">
      <div class="cvs-title"><span>经典简历模板</span><div class="title-right pointer" @click="moreTemplate">查看更多</div></div>
      <div class="template" v-if="templates.length">
        <div class="menu-list">
          <div class="menu" v-for="item in templates" :key="item.title">

            <img :src="images[item.en]" alt="">
            <p class="title">{{item.cn}}</p>
            <p class="desc">{{item.temp_desc}}</p>

            <div class="btn">
              <button v-if="item.cn_img" @click="selectTemplate(item.cn_token, item.cn_img, 'cn')">中文模板</button>
              <button v-if="item.en_img" @click="selectTemplate(item.en_token, item.en_img, 'en')">英文模板</button>
            </div>

          </div>
        </div>
      </div>
    </div>

    <div class="module-item">
      <div class="cvs-title"><span>大牛简历</span><div class="title-right pointer" @click="moreTemplate">查看更多</div></div>
      <div class="cow">
        <div class="cow-menu" v-for="item in (mubans.length > 8 ? 8 : mubans.length)" :key="item" @click="templateDetails(mubans[item - 1])">
          <div class="cow-picture">
            <img :src="mubans[item - 1].img" alt="">
            <img src="https://files.wondercv.com/PC/cvs/resume/bg.png" alt="" srcset="" class="company-logo-bj" v-if="mubans[item - 1].company_logo">
            <img :src="mubans[item - 1].company_logo" alt="" srcset="" v-if="mubans[item - 1].company_logo" class="company-logo">
          </div>
          <p class="text-overflow">{{mubans[item - 1].name}}</p>
        </div>
      </div>
    </div>

  </div>
</template>
<script>
import { mapState } from 'vuex';
import { TEMPLATE_IMAGES } from '@/assets/js/const';
import { dealSignatrue, routerTo } from '@/assets/js/util';
import api from '@/api';
import { get_tUser } from '@/assets/js/util';
import template from '@/assets/json/template';

export default {
  props: {
    noCvSuggestedTemplateList: {
      type: Array,
      default: []
    },
    noCvSampleTemplateList: {
      type: Array,
      default: []
    }
  },
  name: 'CvTemplate',
  data() {
    return {
      images: TEMPLATE_IMAGES,
      mubans: [],
      option: [0],
      temps: [],
      user: {},
      templates: [],

    }
  },
  async created() {
    this.templates = template

    // this.$store.dispatch('cvs/getTemplates');
    // let res = await api.template.getTemplateIndex();
    // this.mubans = res.data.sample_cvs;

    this.user = await get_tUser();
    // let temp_res = await api.cvsV3.getCvsTemplate(this.user.c_t);
    // temp_res.data.names = ['aboard_ba']
    // this.templates.forEach(item => {
    //   if (item.en === temp_res.data.names[0]) {
    //     this.temps.push(item)
    //   }
    // })
    // this.temps = this.templates.filter(i => temp_res.data.names == (i.en))
    this.templates.forEach(item => {
      if (item.en === this.noCvSuggestedTemplateList[0]) {
        this.temps.push(item)
      }
    })
    this.mubans = this.noCvSampleTemplateList
  },
  methods: {
    // 预览简历
    previewCvFunc (data) {
      if (data.cn_img && data.en_img) {
        this.selectTemplate(data.cn_token, data.cn_img, 'cn')
      } else if (data.cn_img && !data.en_img) {
        this.selectTemplate(data.cn_token, data.cn_img, 'cn')
      } else if (!data.cn_img && data.en_img) {
        this.selectTemplate(data.en_token, data.en_img, 'en')
      }
    },
    setOption(index, value) {
      this.$set(this.option, index, value);
    },
    // 立即使用模板
    useTemplateFunc (type) {
      let token = this.temps[0][`${type}_token`]
      routerTo(`/cvs/${token}/editor`)
    },
    // 使用模板
    async useTemplate(index, data) {
      let token = ''
      if (index === 0){
        token = data.cn_token
      }else{
        token = data.en_token
      }
      routerTo(`/cvs/${token}/editor`);
    },
    // 选择模板
    selectTemplate(token, img, type) {
      this.$store.dispatch('app/setAlertData', {
        show: true,
        type: 'job',
        jobImage: img,
        jobToken: token,
        jobType: type,
      })
    },
    moreTemplate() {
      routerTo('/jianlimoban/', '_blank');
    },
    templateDetails(data) {
      routerTo(`/jianlimoban/${data.token}.html`, '_blank');
    }
  },
}
</script>
<style lang="scss" scoped>
.cv-template-main {
  width: 100%;
  box-sizing: border-box;
  // padding: 24px 32px;
  background: #f5f5f7;
  border-radius: 4px;
  overflow: hidden;
  & * {
    box-sizing: border-box;
  }

  .module-item {
    background: #ffffff;
    box-shadow: 0px 1px 6px 0px rgba(3, 47, 129, 0.03);
    border-radius: 6px;
    margin-bottom: 16px;
    padding: 24px;

    &:last-of-type {
      margin-bottom: 0;
    }
  }

  .cvs-title {
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 14px;
    line-height: 14px;
    color: #404040;
    font-weight: 500;
    position: relative;
    margin-bottom: 20px;
    .title-right {
      float: right;
      width: 76px;
      height: 24px;
      border-radius: 12px;
      border: 1px solid #ECECEC;
      box-sizing: border-box;
      line-height: 22px;
      font-size: 13px;
      font-weight: 400;
      color: #606060;
      cursor: pointer;
      text-align: center;

      &:hover {
        color: #9c9c9c;
      }
    }
  }

  // 推荐模板（新）
  .recommend-template-box {

    .recommend-template-item {
      display: flex;
      // align-items: center;

      .template-item-img-box {
        position: relative;
        width: 242px;
        height: 322px;
        border-radius: 4px;
        margin-right: 20px;
        cursor: pointer;

        &:hover {

          .template-item-img {
            border: none;
            box-shadow: 0px 2px 12px 0px rgba(25, 44, 81, 0.1);
          }

          >i {
            display: block;
          }
        }

        .template-item-img {
          width: 242px;
          height: 322px;
          object-fit: cover;
          border: 1px solid #ececec;
          border-radius: 4px;
        }

        >i {
          display: none;
          font-size: 20px;
          font-weight: 500;
          position: absolute;
          right: 14px;
          bottom: 14px;
          width: 32px;
          height: 32px;
          background: rgba(0, 0, 0, 0.5);
          border-radius: 4px;

          &:hover {
            background: rgba(0, 0, 0, 0.7);
          }

          &::before {
            color: #ffffff;
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
          }
        }

      }

      .template-item-info {
        flex: 1;

        .template-item-title {
          display: flex;
          align-items: center;
          margin-bottom: 6px;

          >h6 {
            font-size: 18px;
            font-weight: 500;
            color: #404040;
            line-height: 25px;
            margin-right: 8px;
          }

          >span {
            font-size: 12px;
            font-weight: 400;
            color: #FF6644;
            line-height: 12px;
            padding: 4px 8px;
            background: #FFF6F4;
            border-radius: 10px;
          }
        }

        .template-item-subtitle {
          font-size: 14px;
          font-weight: 400;
          color: #606060;
          line-height: 20px;
          margin-bottom: 16px;
        }

        .template-item-hr-box {
          padding: 16px 16px 18px;
          background: #F9F9F9;
          border-radius: 6px;
          margin-bottom: 20px;

          .template-item-hr-header {
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin-bottom: 8px;

            >div {
              display: flex;
              align-items: center;

              .template-item-hr-avatar {
                width: 22px;
                height: 22px;
                object-fit: cover;
                border-radius: 50%;
                margin-right: 8px;
              }

              .template-item-hr-name {
                font-size: 12px;
                font-weight: 500;
                color: #404040;
                line-height: 17px;
              }

            }

            .template-item-hr-icon {
              width: 28px;
            }

          }

          .template-item-hr-desc {
            font-size: 12px;
            font-weight: 400;
            color: #606060;
            line-height: 17px;
          }
        }

        .template-item-btn-box {
          display: flex;
          align-content: center;

          .template-item-btn {
            width: 94px;
            height: 36px;
            background: #ffffff;
            padding: 0;
            font-size: 14px;
            font-weight: 500;
            border-radius: 4px;
            box-sizing: border-box;
            margin-right: 12px;

            &.cn {
              color: #ffffff;
              background: #FF6644;
            }

            &.en {
              color: #ff6644;
              background: #ffffff;
              border: 1px solid #ff6644;
            }

            &:last-of-type {
              margin-right: 0;
            }

            &:hover {
              opacity: 0.8;
            }
          }

          .service-link{
            right: -12px;
            top: 4px;
            display: flex;
            align-items: center;
            color: #462A03;
            font-weight: 500;
            &:hover{
              opacity: .8;
            }
            .iconfont{
              display: block;
              width: 32px;
              height: 32px;
              background: linear-gradient(124deg, #F9F0E1 0%, #FFDEB0 100%);
              border-radius: 50%;
              text-align: center;
              line-height: 32px;
              position: relative;
              z-index: 2;
            }
            .text{
              width: 95px;
              height: 27px;
              background: linear-gradient(50deg, #FFF8EE 0%, #FFDEB0 100%);
              border-radius: 0px 100px 100px 0px;
              box-sizing: border-box;
              padding-left: 18px;
              line-height: 27px;
              position: relative;
              left: -12px;
            }
          }
        }   

      }

    }
  }

  // 推荐模板（旧）
  .recommeed {
    margin-bottom: 52px;
    display: flex;
    align-items: center;
    .recommeed-menu {
      width: 348px;
      
      &:first-child {
        margin-right: 102px;
      }
      .recommeed-title {
        font-size: 14px;
        color: #404040;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .recommeed-btn {
          display: flex;
          align-items: center;
          justify-content: flex-end;
          button {
            display: block;
            width: 44px;
            height: 22px;
            border: 1px solid #4183FF;
            border-radius: 2px;
            color: #4183FF;
            background: #fff;
            &.active {
              background: #4183FF;
              color: #fff;
            }
            &:last-child {
              margin-left: 10px;
            }
          }
        }
      }
      .recommeed-img {
        width: 100%;
        height: 472px;
        margin-top: 10px;
        position: relative;
        border:1px solid rgba(232,232,232,1);
        img {
          display: block;
          width: 100%;
          height: 100%;
          position: relative;
          z-index: 1;
        }
        &:hover .recommeed-cover {
          display: flex;
        }
        .recommeed-cover {
          display: none;
          width: 100%;
          height: 100%;
          background: rgba(0, 0, 0, .5);
          position: absolute;
          top: 0;
          left: 0;
          z-index: 2;
          align-items: center;
          justify-content: center;
          button {
            width: 180px;
            height: 40px;
            color: #fff;
            font-size: 14px;
            border-radius: 2px;
            background: #ff4f4c;
          }
        }
      }
      .recommeed-info {
        margin-top: 12px;
        font-size: 14px;
        color: #9C9C9C;
        line-height: 24px;
        span {
          display: inline-block;
          height: 22px;
          width: 56px;
          background:rgba(255,79,76,.13);
          color: #FF4F4C;
          text-align: center;
          border-radius: 11px;
          line-height: 22px;
          margin-right: 10px;
        }
      }
    }

    .recommend-template-item {

    }

  }
  // 模板
  .template {
    // width: 1074px;
    top: 10px;
    // padding-bottom: 52px;
    // margin-top: -30px;
    
    .menu-list {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;

      .menu {
        position: relative;
        display: flex;
        flex-direction: column;
        align-items: center;
        width: 178px;
        background: #FFFFFF;
        border-radius: 8px;
        border: 1px solid #ECECEC;
        box-sizing: border-box;
        padding: 20px 0 24px;
        cursor: pointer;

        &:nth-child(1),
        &:nth-child(2),
        &:nth-child(3),
        &:nth-child(4) {
          margin-bottom: 16px;
        }

        &:hover {
          border-color: #ffffff;
          box-shadow: 0px 2px 12px 0px rgba(25, 44, 81, 0.1);

          .btn {
            display: flex;
          }

        }

        >img {
          width: 44px;
          height: 44px;
          margin-bottom: 20px;
        }

        >p {
          text-align: center;
          padding: 0 14px;
        }

        .title {
          font-size: 15px;
          font-weight: 500;
          color: #404040;
          line-height: 21px;
          margin-bottom: 5px;
        }

        .desc {
          font-size: 12px;
          font-weight: 400;
          color: #9C9C9C;
          line-height: 17px;
        }

        .btn {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          display: none;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          background: #FFFFFF;
          border-radius: 0 0 8px 8px;

          >button {
            width: 154px;
            height: 35px;
            color: #FF6644;
            background: #ffffff;
            font-size: 14px;
            font-size: 13px;
            font-weight: 400;
            line-height: 27px;
            padding: 0;
            border-radius: 4px;
            border: 1px solid #FF6644;
            box-sizing: border-box;

            &:hover {
              color: #fff;
              background: #FF6644;
            }

            &:nth-child(2) {
              margin-top: 6px;
            }

          }
        }

      }
    }

  }
  // 大牛简历
  .cow {
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
    .cow-menu {
      width: 178px;
      margin-bottom: 24px;
      cursor: pointer;
      .cow-picture {
        width: 100%;
        height: 237px;
        padding: 10px;
        border-radius: 4px;
        border: 1px solid #ECECEC;
        position: relative;
        &:hover {
          border: none;
          box-shadow: 0px 2px 12px 0px rgba(25, 44, 81, 0.1);
        }
        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
        .company-logo-bj {
          width: 26px;
          height: 31px;
          position: absolute;
          left: 16px;
          top: -3px;
        }
        .company-logo {
          width: 20px;
          height: 20px;
          position: absolute;
          left: 19px;
          top: 4px;
          border-radius: 50%;
          z-index: 1;
        }
      }
      p {
        margin-top: 12px;
        color: #404040;
        font-size: 14px;
        text-align: center;
      }
    }
  }
}
</style>